var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgP = function SvgP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.273V4.727h5.185c1.131 0 2.069.206 2.812.618.744.412 1.3.976 1.67 1.69.368.71.553 1.51.553 2.401 0 .895-.187 1.7-.56 2.415-.37.71-.929 1.273-1.677 1.69-.743.412-1.678.618-2.805.618H9.612V12.3h3.367c.715 0 1.295-.124 1.74-.37a2.32 2.32 0 0 0 .98-1.023c.208-.43.312-.92.312-1.47 0-.55-.104-1.037-.312-1.463a2.241 2.241 0 0 0-.987-1.001c-.445-.242-1.032-.363-1.762-.363h-2.755v12.664H8Z",
    fill: "#21272A"
  })));
};
export default SvgP;